const firebaseConfig = {
    apiKey: "AIzaSyAupdBTynL0SvXC2fF3lfCUMch8L7wTYUk",
    authDomain: "ema-jon-simple-a85e8.firebaseapp.com",
    projectId: "ema-jon-simple-a85e8",
    storageBucket: "ema-jon-simple-a85e8.appspot.com",
    messagingSenderId: "319549546279",
    appId: "1:319549546279:web:b99970a8999ab05fae1302",
    measurementId: "G-BGT6831LCG"
  };

  export default firebaseConfig;